// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const LazyImage = require('client-v2/common/components/lazy-image')
const { usePropsEventCallback } = require('client-v2/common/hooks/callbacks')
const { collectionProfileHref } = require('client-v2/common/models/collection/actions')

const bem = BemEntity('MoodCard')

function MoodCard(props) {
  const { collection } = props
  let coverImageUrl = props['cover_image_url']
  if (collection['cover_image_urls']) {
    coverImageUrl = collection['cover_image_urls'].large
  }
  // Hooks
  const onCardClick = usePropsEventCallback(props, 'onCardClick')
  // Render
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      ),
      onClick: onCardClick
    },
      tag('a', {
        className: bem.element('inner'),
        href: collectionProfileHref(collection)
      },
        tag(LazyImage, {
          className: bem.element('image'),
          sources: [ coverImageUrl, ...collection.images ],
          target: '_blank'
        }),
        tag('div', {
          className: bem.element('name')
        },
          collection.name
        )
      )
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const CollectionModelRecord = require('client-v2/common/models/collection/record')

  MoodCard.propTypes = {
    // Values
    className: PropTypes.string,
    collection: PropTypes.shape(CollectionModelRecord.propTypes).isRequired,
    // Callbacks
    onCardClick: PropTypes.func
  }
}

module.exports = MoodCard
